/**
 * Figures the public stats feed does not carry, kept in a git-tracked JSON file so they can be
 * refreshed on their own, without editing code.
 *
 * `data.ulule.com/stats.json` exposes totals, per-category amounts, per-year success rates and
 * `amount_avg`, but nothing about overshoot, share-driven contributions, the smallest successful
 * collection, or the legal status of project owners. Until something serves those, they are
 * maintained by hand in `figures.json` and baked into the page at build time — so refreshing them
 * takes a deploy, which is the trade for not having a source yet.
 *
 * Not here: the leaderboards and the biggest collection, which `collections.ts` derives live, and
 * the women-led claim, which is copy rather than a figure (see `STATUS` in `content.ts`).
 */
import figures from './figures.json'

/** One slice of the "par statut" split. */
export type OwnerType = {
  label: string
  percent: number
}

export type ManualFigures = {
  /** Average share of its target a successful collection reaches, in percent (125 = +25%). */
  overshootPercent: number
  /** Share of contributions that follow a share of the campaign, in percent. */
  shareDrivenPercent: number
  /** Smallest successful collection, in euros. */
  smallestSuccessEur: number
  /** Share of collections by owner type. Sums to 100 — `figures.test.ts` holds that. */
  ownerTypes: OwnerType[]
}

/** Annotated, so a dropped or mistyped key in the JSON is a type error, not a blank figure. */
export const FIGURES: ManualFigures = figures
